import Analytics from '../src/Analytics/index';
export default Analytics;
